import { render, staticRenderFns } from "./CartPopover.vue?vue&type=template&id=45d91c40"
import script from "./CartPopover.vue?vue&type=script&lang=ts"
export * from "./CartPopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports